module.exports = __webpack_public_path__ + "static/media/icon-source-default.dfbff4e7.svg";